import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, LoadingSpinner } from 'edenred-ui';
import { useDispatch } from 'react-redux';

import { useManageBenefits } from '@epi-containers/ManageBenefits/hooks';
import { SELECTED_BENEFIT_PARAM } from '@epi-constants/benefitTypes';
import { ActivatedBenefitsList } from '@epi-containers/ManageBenefits/components/ActivateBenefits/ActivatedBenefitsList';
import { ActivateBenefitGroupsForm } from '@epi-forms/ActivateBenefitGroups/ActivateBenefitGroups';
import OnboardingStepper from '@epi-components/OnboardingStepper/OnboardingStepper';
import { useCreateGroupSettingsMutation } from '@epi-api/manageBenefits/manageBenefitsApi';
import { goToPage } from '@epi-actions/navigation';
import { routerPaths } from '@epi-constants/routerPaths';
import { showNotification } from '@epi-actions/overlays';

export const ActivateBenefits = () => {
  const { search } = useLocation();
  const urlParams = new URLSearchParams(search);
  const { inactiveAvailableBenefits } = useManageBenefits();
  const dispatch = useDispatch();
  const [createGroupSettings, { isSuccess, isError }] =
    useCreateGroupSettingsMutation();

  const selectedBenefitsIds = urlParams.get(SELECTED_BENEFIT_PARAM);
  const selectedBenefitsIdsArray = selectedBenefitsIds?.split(',');

  const selectedBenefits = selectedBenefitsIdsArray
    ? inactiveAvailableBenefits.filter(benefit =>
        selectedBenefitsIdsArray.includes(benefit.id.toString())
      )
    : null;

  const goNextPage = () => {
    dispatch(goToPage(routerPaths.beneficiaries));
  };

  if (!selectedBenefitsIds) {
    dispatch(goToPage(routerPaths.manageBenefits));
  }

  useEffect(() => {
    if (isSuccess) {
      goNextPage();
    }
    if (isError) {
      dispatch(showNotification({ message: 'messages.error' }, 'error'));
    }
  }, [isSuccess, isError]);

  if (!selectedBenefits?.length) {
    return <LoadingSpinner />;
  }

  return (
    <ActivateBenefitGroupsForm
      selectedBenefits={selectedBenefits}
      mutationTrigger={createGroupSettings}
    >
      <Box>
        <OnboardingStepper />
        <ActivatedBenefitsList selectedBenefits={selectedBenefits} />
      </Box>
    </ActivateBenefitGroupsForm>
  );
};
